const colorNewTagLabelMap = [
  'Muted Terracotta',
  'Butterscotch',
  'Daffodil',
  'Sand Gold',
  'Pale Peach',
  'Sunset',
  'Coral Pink',
  'Carolina Blue',
  'Coronet Blue',
  'Cornflower',
  'Lilac',
  'Oyster White',
  'Buttercream',
  'Mushroom Taupe',
  'Slate Gray',
  'Jasmine Green',
  'Mineral Green',
  'Teal',
  'Dusty Jacobean Rose',
  'Dusty Lavender Toile',
  'Spruce Sketch Floral',
  'Mist Peony Floral',
  'Lavender Mist Floral',
  'Antique Azure Rose',
  'Golden Peony',
].reduce((acc, cur) => {
  acc[cur.toLowerCase()] = 1;
  return acc;
}, {});

export const isNewColorOption = (defaultColorLabel: string) => {
  return (
    typeof defaultColorLabel === 'string' &&
    !!defaultColorLabel &&
    !!colorNewTagLabelMap[defaultColorLabel.toLowerCase()]
  );
};
